import { Component } from '@angular/core';

import {AppState, TAppState} from './app-state';
import {Quiz} from './quiz';

@Component({
  selector: 'fllt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
    private _state: TAppState = AppState.START;
    public quiz: Quiz;

    public get stateIsStart() {
        return this._state === AppState.START;
    }

    public get stateIsQuestion() {
        return this._state === AppState.QUESTION;
    }

    public get stateIsResult() {
        return this._state === AppState.RESULT;
    }

    startTest() {
        this.quiz = new Quiz();
        this._state = AppState.QUESTION;
    }

    getResult() {
        this._state = AppState.RESULT;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts